import React from "react";
import { Container, Typography, Box } from "@mui/material";
import SEOHead from "../../components/SEO/SEOHead";

export default function PoliticaPrivacidade() {
    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <SEOHead
                title="Política de Privacidade — HL Software"
                description="Saiba como a HL Software coleta, usa e protege seus dados pessoais em conformidade com a LGPD."
                canonical="https://www.hlsoftware.com.br/politica-de-privacidade"
                robots="noindex,follow"
            />
            <Typography variant="h4" gutterBottom color="primary">
                Política de Privacidade
            </Typography>

            <Typography variant="body1" paragraph>
                Na HL Software, respeitamos sua privacidade e estamos comprometidos com a proteção dos seus dados pessoais.
                Esta Política de Privacidade descreve como coletamos, usamos e protegemos suas informações ao utilizar nossos sistemas e serviços.
            </Typography>

            <Box mt={4}>
                <Typography variant="h6" gutterBottom>
                    1. Coleta de Informações
                </Typography>
                <Typography variant="body2" paragraph>
                    Podemos coletar informações como nome, e-mail, telefone, CPF/CNPJ e outros dados fornecidos por você
                    ao se cadastrar, contratar um serviço ou interagir conosco.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    2. Uso das Informações
                </Typography>
                <Typography variant="body2" paragraph>
                    As informações coletadas são utilizadas para:
                    - fornecer nossos serviços;
                    - realizar cobranças;
                    - enviar comunicações relevantes (como alertas e atualizações);
                    - melhorar a experiência do usuário.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    3. Compartilhamento
                </Typography>
                <Typography variant="body2" paragraph>
                    Não compartilhamos suas informações pessoais com terceiros, exceto quando necessário para o
                    funcionamento dos nossos serviços (como integrações com provedores de pagamento ou comunicação) ou
                    exigido por lei.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    4. Segurança
                </Typography>
                <Typography variant="body2" paragraph>
                    Adotamos boas práticas de segurança da informação para proteger seus dados contra acessos não autorizados,
                    perdas ou alterações indevidas.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    5. Seus Direitos
                </Typography>
                <Typography variant="body2" paragraph>
                    Você pode solicitar acesso, correção ou exclusão dos seus dados pessoais a qualquer momento. Basta entrar em
                    contato conosco pelo e-mail <strong>contato@hlsoftware.com.br</strong>.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    6. Alterações nesta Política
                </Typography>
                <Typography variant="body2" paragraph>
                    Podemos atualizar esta política periodicamente. Recomendamos que você a revise com frequência para
                    estar sempre informado.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="body2" color="text.secondary">
                    Última atualização: 24 de julho de 2025
                </Typography>
            </Box>
        </Container>
    );
}
